<template lang="pug">
	
	div.color-palette
		div.dropdown
						
			div.form-control.dropdown-toggle(href='#', role='button', data-toggle='dropdown', aria-haspopup='true', aria-expanded='false')
				span(v-show="!value") Selecionar
				div.color-palette-preview(v-show="value", :style="{ 'background-color': value }")
				
			.dropdown-menu(aria-labelledby='dropdownMenuLink')

				table.color-palette-table
					tr(v-for='palette in colors')
						td(v-for='color in palette', @click="setColor(color)")
							div.color-select(:style="{ 'background-color': color }")
</template>

<script>

const COLOR_PALETTE_COLORS = [
	[ '#330000', '#331900', '#333300', '#193300', '#003300', '#003319', '#003333', '#001933', '#000033', '#190033', '#330033', '#330019', '#000000' ],
	[ '#660000', '#663300', '#666600', '#336600', '#006600', '#006633', '#006666', '#003366', '#000066', '#330066', '#660066', '#660033', '#202020' ],
	[ '#990000', '#994C00', '#999900', '#4C9900', '#009900', '#00994C', '#009999', '#004C99', '#000099', '#4C0099', '#990099', '#99004C', '#404040' ],
	[ '#CC0000', '#CC6600', '#CCCC00', '#66CC00', '#00CC00', '#00CC66', '#00CCCC', '#0066CC', '#0000CC', '#6600CC', '#CC00CC', '#CC0066', '#606060' ],
	[ '#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF', '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080' ],
	[ '#FF3333', '#FF9933', '#FFFF33', '#99FF33', '#33FF33', '#33FF99', '#33FFFF', '#3399FF', '#3333FF', '#9933FF', '#FF33FF', '#FF3399', '#A0A0A0' ],
	[ '#FF6666', '#FFB266', '#FFFF66', '#B2FF66', '#66FF66', '#66FFB2', '#66FFFF', '#66B2FF', '#6666FF', '#B266FF', '#FF66FF', '#FF66B2', '#C0C0C0' ],
	[ '#FF9999', '#FFCC99', '#FFFF99', '#CCFF99', '#99FF99', '#99FFCC', '#99FFFF', '#99CCFF', '#9999FF', '#CC99FF', '#FF99FF', '#FF99CC', '#E0E0E0' ],
	[ '#FFCCCC', '#FFE5CC', '#FFFFCC', '#E5FFCC', '#CCFFCC', '#CCFFE5', '#CCFFFF', '#CCE5FF', '#CCCCFF', '#E5CCFF', '#FFCCFF', '#FFCCE5', '#FFFFFF' ]
];

export default {

	name: 'ColorPalette',

	props: ['value'],

	data () {
		return {
			colors: COLOR_PALETTE_COLORS
		};
	},

	methods: {

		setColor (color) {
			this.$emit('input', color);
		}
	}
};

</script>

<style lang="scss" scoped>

@import "../../styles/variaveis";
@import "../../styles/mixins";


.color-palette {
	
	.dropdown {

		div.form-control {
			width: 100%;
			height: 32px;
			text-align: left;
			cursor: pointer;
			position: relative;

			&.dropdown-toggle::after {
				display: block;
				float: right;
				margin-top: 8px;
			}

			.color-palette-preview {
				position: absolute;
				display: block;
				float: left;
				top: 6px;
				left: 12px;
				bottom: 6px;
				right: 30px;
			}
		}
	}

	.dropdown-menu {
		width: 100%;
		padding: 5px;
	}

	&.invalid div.form-control {
		border-color: $error-color;
	}
}

.color-palette-table {
	width: 100%;
	border-spacing: 0;

	tr {
		
		td {
			width: 7.68%;
			height: 20px;
			border: 0;
			cursor: pointer;
			
			.color-select {
				width: 100%;
				height: 100%;
			}

			&:hover .color-select {
				border-color: #000;
				border: solid 1px #000;
			}
		}
	}	
}
</style>


// WEBPACK FOOTER //
// ColorPalette.vue?55ffcf6a